/**
 * Statement of Work API field mapping (POST /sow, PUT /sow/:id).
 * API expects outerDiameterInch, wallThicknessMm, expectedPipeLength as numbers when set.
 */

const trimOrUndef = (v) => {
  if (v === undefined || v === null) return undefined;
  const s = String(v).trim();
  return s === '' ? undefined : s;
};

const toOptionalFiniteNumber = (v) => {
  const t = trimOrUndef(v);
  if (t === undefined) return undefined;
  const n = Number(t);
  return Number.isFinite(n) ? n : undefined;
};

/**
 * @returns {Record<string, number>} only keys with valid numeric values
 */
export function buildSowMeasurementApiFields(odInches, wallThicknessMm, expectedPipeLength) {
  const out = {};
  const od = toOptionalFiniteNumber(odInches);
  if (od !== undefined) out.outerDiameterInch = od;
  const wt = toOptionalFiniteNumber(wallThicknessMm);
  if (wt !== undefined) out.wallThicknessMm = wt;
  const el = toOptionalFiniteNumber(expectedPipeLength);
  if (el !== undefined) out.expectedPipeLength = el;
  return out;
}

/** Normalize one SOW record from API so UI can keep using odInches. */
export function normalizeSowRecordFromApi(item) {
  if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
  const next = { ...item };
  if (next.outerDiameterInch !== undefined && next.outerDiameterInch !== null && next.odInches === undefined) {
    next.odInches = next.outerDiameterInch;
  }
  return next;
}
